// tween.ts (shared singleton)
import { Group } from '@tweenjs/tween.js'
export const tweenGroup = new Group()

